import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { activityService } from 'features/cost-analysis/team/activities/api/activity.service';
import { ActivitiesColumns } from '../activities';

export const ActivitiyList = () => {
  const translationPrefix = 'pages.activities.list';
  const { t } = useTranslation();

  const columns: GridColDef[] = ActivitiesColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid columns={columns} service={activityService} />
    </TenantPage>
  );
};

export default ActivitiyList;
